<template>
  <article id="home">
    <h1>hello</h1>
    <section class="test">
        Welcome to my <span class="red">prickly</span> corner of the interwebs.
        <br>
        My portfolio and more information about me and what I do can be found in the menu to the left!
    </section>
    <br>
    <div id="medium-widget"></div>
    <section id="cactus" class="banner"></section>
    <section id="summer" class="banner"></section>
  </article>
</template>

<script>
export default {
  name: 'Home',
  mounted () {
    // Set up Medium article feed
    const feedScript = document.createElement('script')
    feedScript.setAttribute('src', 'https://medium-widget.pixelpoint.io/widget.js')
    document.head.appendChild(feedScript)

    const initScript = document.createElement('script')
    initScript.innerText = 'MediumWidget.Init({renderTo: \'#medium-widget\', params: {"resource":"https://medium.com/@alexander.wester","postsPerLine":2,"limit":4,"picture":"small","fields":["description","author","claps","publishAt"],"ratio":"original"}})'

    // Wait for the widget.js script to load before running the init code
    feedScript.addEventListener('load', () => {
      document.body.appendChild(initScript)

      const articlesSection = document.getElementsByClassName('medium-widget')[0]
      const articlesTitle = document.createElement('h3')
      articlesTitle.style.fontWeight = 'normal'
      articlesTitle.innerText = 'The following are my latest medium articles:'
      articlesSection.prepend(articlesTitle)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../variables.scss';

#cactus {
  background: url('../assets/img_pattern.webp') repeat, url('../assets/cactus.webp')  center center no-repeat;
  background-attachment: scroll, fixed;
  background-size: auto, cover;
}

#summer {
  background: url('../assets/img_pattern.webp') repeat, url('../assets/hay.webp')  center center no-repeat;
  background-attachment: scroll, fixed;
  background-size: auto, cover;
}

</style>
